import { defineMessages } from 'react-intl';

const messages = defineMessages({
  copy: {
    id: 'Footer.Copy',
    defaultMessage: 'United Natural Foods, Inc.',
  },
});

export default messages;
